import { render, staticRenderFns } from "./total-dealer.vue?vue&type=template&id=0697d1df&"
import script from "./total-dealer.vue?vue&type=script&lang=js&"
export * from "./total-dealer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports